/* global Swiper jQuery MktoForms2 */

/*
 * Enable fancybox overlay popup
 */

// Initial call to the function when the page is loaded
(function ($) {
	"use strict";

	$("[data-fancybox]").fancybox({
		toolbar: false,
		smallBtn: true,
		iframe: {
			preload: false,
		},
	});

})(jQuery);
/*
 * before submitting the form, calculate the score and then redirect the user to a URL like
	https://qualys-html-to-pdf-0d3555d590c9.herokuapp.com/generate-pdf?grade=a%2b&name=Abdullah%20Yahya&company=Qualys&designation=Product%20Manager,%20Web&country=United%20States

   client-side JS marketo code processes in the following order:
	1. /asset/script/marketo.js
	2. /vmdr-health-check/index.js (this script)
 */
(function ($, MktoForms2) {
	"use strict";
	var mySwiper = new Swiper("#questionnaire-swiper", {
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			el: ".swiper-pagination",
			type: "progressbar"
		},
		autoHeight: true,
		autoplay: false,
		allowSlideClick: false,
		spaceBetween: 30,
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		on: {
			init: function() {
				document.querySelectorAll(".pro-tip").forEach(proTip => {
					proTip.addEventListener("click", function() {
						console.log("click");
						const nextElement = this.nextElementSibling;
						console.log(nextElement);
						// $(this).closest(".q-pro").next(".help_links").toggleClass("hide");
						if (nextElement && nextElement.classList.contains("pro-tip-data")) {
							nextElement.classList.toggle("hidden");
							mySwiper.update();

						}
					});
				});
			},
			touchStart: function () {
				mySwiper.allowSlidePrev = false;
				mySwiper.allowSlideNext = false;
			},
			touchEnd: function () {
				mySwiper.allowSlidePrev = true;
				mySwiper.allowSlideNext = true;
			},
			slideChange: function () {
				var targetElement = document.getElementById(
					"questionnaire-section"
				);
				var offset = targetElement
					? targetElement.offsetTop -
                      document.querySelector(".q-header").offsetHeight
					: 0;
				if (targetElement) {
					window.scrollTo({ top: offset, behavior: "smooth" });
				}
			},
			slideChangeTransitionEnd: function () {
				let activeIndex = this.activeIndex;
				let maxIndex =
                    document.getElementsByClassName("swiper-slide").length - 1;
				if (activeIndex === maxIndex) {
					let nextBtnEl = document.querySelector(
						".swiper-button-next"
					);
					nextBtnEl.textContent = "Submit";
					if (nextBtnEl.classList.contains("swiper-button-next")) {
						nextBtnEl.classList.remove("swiper-button-next");
						nextBtnEl.setAttribute("id", "mock-submit");
						document.getElementById("mock-submit").disabled =
                            "true";
						document
							.getElementById("mock-submit")
							.addEventListener("click", function (e) {
								e.preventDefault();
								document
									.querySelector(
										"button[type='submit'].mktoButton"
									)
									.click();
							});
					} else {
						console.log("id already exists");
					}
					disableNextBtn(true);
				} else {
					disableNextBtn(false);
				}
			},
		},
	});

	function disableNextBtn(isLastIndex = false) {
		var activeFieldset = document.querySelector(
			"fieldset.swiper-slide-active"
		);
		if (activeFieldset) {
			let questions = activeFieldset.querySelectorAll(".question");
			let checkedVal = Array.from(questions, (question) => {
				let choicesDiv = question.querySelector(".choices");
				return choicesDiv
					? Array.from(choicesDiv.children).some((child) =>
						child.classList.contains("checked")
					)
					: false;
			});
			let countOfTrue = checkedVal.filter((value) => value).length;
			let infoText = document.querySelector(".paragraph--1.info-text");
			if (countOfTrue === questions.length) {
				infoText.style.display = "none";
				if (!isLastIndex) {
					let nextBtn = document.querySelector(".swiper-button-next");
					nextBtn.classList.remove("swiper-button-disabled");
				} else {
					document.getElementById("mock-submit").disabled = false;
				}
			} else if (countOfTrue < questions.length) {
				infoText.style.display = "block";
				if (!isLastIndex) {
					let nextBtn = document.querySelector(".swiper-button-next");
					nextBtn.classList.add("swiper-button-disabled");
				} else {
					document
						.getElementById("mock-submit")
						.classList.add(
							"swiper-button-next",
							"swiper-button-disabled"
						);
				}
			}
		}
	}
	const gradeToNumeric = {
		"A+": 3,
		A: 2,
		B: 1,
		F: 0,
	};
	const sensorsRangeMapping = {
		"A+": [
			"sensorsRange02",
			"sensorsRange03",
			"sensorsRange04",
			"sensorsRange05",
			"sensorsRange07",
			"sensorsRange09",
			"sensorsRange10",
		],
		A: [
			"sensorsRange02",
			"sensorsRange04",
			"sensorsRange09",
			"sensorsRange10",
			"sensorsRange05",
		],
		B: [
			"sensorsRange01",
			"sensorsRange04",
			"sensorsRange10",
			"sensorsRange11",
		],
	};

	// question 2 mapping
	const frequencyMapping = {
		frequency01: "A+",
		frequency02: "A+",
		frequency03: "A",
		frequency04: "B",
		frequency05: "F",
	};

	// question 3 mapping
	const percentageMapping = {
		percentage01: "A+",
		percentage02: "A",
		percentage03: "B",
		percentage04: "B",
	};

	// question 4 mapping
	const classifyGroupMapping = {
		classifygroup01: "A+",
		classifygroup02: "F",
		classifygroup03: "F",
		classifygroup04: "A",
		classifygroup05: "B",
	};

	// question 5 mapping
	const digitalCertificatesMapping = {
		digitalCertificates01: "A+",
		digitalCertificates02: "A",
		digitalCertificates03: "A",
		digitalCertificates04: "B",
		digitalCertificates05: "F",
	};

	// question 6 mapping
	const authenticationMapping = {
		authentication01: "A+",
		authentication02: "A",
		authentication03: "B",
		authentication04: "B",
	};

	// question 7 mapping
	const agentlessTrackingMapping = {
		agentlessTracking01: "B",
		agentlessTracking02: "B",
		agentlessTracking03: "A+",
		agentlessTracking04: "A",
		agentlessTracking05: "F",
	};

	// question 8 mapping
	const mergeVulnerabilityMapping = {
		mergeVulnerability01: "A+",
		mergeVulnerability02: "B",
	};

	// question 9 mapping
	const exploitableVulnerabilitiesMapping = {
		exploitableVulnerabilities01: "B",
		exploitableVulnerabilities02: "A",
		exploitableVulnerabilities03: "A",
		exploitableVulnerabilities04: "A+",
	};

	// question 10 mapping
	const sCAMapping = {
		SCA01: "A",
		SCA02: "A+",
		SCA03: "A+",
		SCA04: "A",
		SCA05: "B",
	};

	// question 11 mapping
	const pCIASVScanningMapping = {
		pCIASVScanning01: "A+",
		pCIASVScanning02: "B",
		pCIASVScanning03: "F",
	};

	// question 12 mapping
	const createTicketsMapping = {
		createTickets01: "A+",
		createTickets02: "A+",
		createTickets03: "A+",
		createTickets04: "A",
		createTickets05: "A",
		createTickets06: "B",
	};

	// question 13 mapping
	const prioritizingVulnerabilitiesMapping = {
		prioritizingVulnerabilities01: "A",
		prioritizingVulnerabilities02: "A",
		prioritizingVulnerabilities03: "A+",
		prioritizingVulnerabilities04: "B",
		prioritizingVulnerabilities05: "F",
	};

	// question 14 mapping
	const prioritizingAssetsMapping = {
		prioritizingAssets01: "A+",
		prioritizingAssets02: "A+",
		prioritizingAssets03: "B",
		prioritizingAssets04: "F",
	};

	// question 15 mapping
	const mitreATTCKMapping = {
		mitreATTCK01: "A+",
		mitreATTCK02: "A+",
		mitreATTCK03: "B",
		mitreATTCK04: "F",
	};

	// question 16 mapping
	const patchesDeployMapping = {
		patchesDeploy01: "B",
		patchesDeploy02: "A+",
		patchesDeploy03: "A",
	};

	// question 17 mapping
	const purgeRulesMapping = {
		purgeRules01: "A+",
		purgeRules02: "A",
		purgeRules03: "B",
	};
	disableNextBtn();
	let name, company, questionnaireForm;

	questionnaireForm = document.getElementById("questionnaire-form");

	function getFinalGrade(grades) {
		// Initialize sumOfGrades to keep track of the total numeric value of grades
		let sumOfGrades = 0,
			finalGrade;

		// Iterate through grades array and convert each grade to its numeric value
		grades.forEach((grade) => {
			sumOfGrades += gradeToNumeric[grade] || 0;
		});

		if (sumOfGrades > 45) {
			finalGrade = "A+";
		} else if (sumOfGrades > 25 && sumOfGrades <= 45) {
			finalGrade = "A";
		} else {
			finalGrade = "B";
		}

		return finalGrade.toLowerCase();
	}

	MktoForms2.whenReady(function (form) {
		let finalGrade, params;

		function getSectionGrade(gradesKV) {
			const fieldsetLabelsObject = {};
			const questionnaires = document.querySelectorAll(".questionnaire");
			questionnaires.forEach(function (fieldset, index) {
				const inputLabelsObject = {};
				const inputs = fieldset.querySelectorAll("input");
				inputs.forEach(function (input) {
					const inputName = input.getAttribute("name");
					const inputValue = input.value;
					inputLabelsObject[inputName] = inputValue;
				});
				fieldsetLabelsObject["fieldset" + (index + 1)] =
                    inputLabelsObject;
			});

			const combinedGrades = {};
			for (const fieldsetKey in fieldsetLabelsObject) {
				if (fieldsetLabelsObject.hasOwnProperty(fieldsetKey)) {
					const fieldsetLabels = fieldsetLabelsObject[fieldsetKey];
					const combinedFieldset = {};
					for (const labelKey in fieldsetLabels) {
						if (fieldsetLabels.hasOwnProperty(labelKey)) {
							const gradeObj = gradesKV.find(
								(obj) => obj.name === labelKey
							);
							if (gradeObj) {
								combinedFieldset[labelKey] = gradeObj.grade;
							}
						}
					}
					combinedGrades[fieldsetKey] = combinedFieldset;
				}
			}
			function replaceGradesWithNumeric(obj) {
				for (const fieldsetKey in obj) {
					if (obj.hasOwnProperty(fieldsetKey)) {
						const fieldset = obj[fieldsetKey];

						for (const labelKey in fieldset) {
							if (
								fieldset.hasOwnProperty(labelKey) &&
                                gradeToNumeric[fieldset[labelKey]] !== undefined
							) {
								fieldset[labelKey] =
                                    gradeToNumeric[fieldset[labelKey]];
							}
						}
					}
				}
			}
			replaceGradesWithNumeric(combinedGrades);
			function transformObject(obj) {
				const transformedObject = {};

				for (const fieldsetKey in obj) {
					if (obj.hasOwnProperty(fieldsetKey)) {
						const fieldset = obj[fieldsetKey];
						transformedObject[fieldsetKey] =
                            Object.values(fieldset);
					}
				}
				return transformedObject;
			}
			const transformedObject = transformObject(combinedGrades);
			function calculateSum(arr) {
				return arr.reduce((acc, value) => acc + value, 0);
			}

			function transformObjectWithSums(obj) {
				const transformedObject = {};

				for (const fieldsetKey in obj) {
					if (obj.hasOwnProperty(fieldsetKey)) {
						const sum = calculateSum(obj[fieldsetKey]);
						transformedObject[fieldsetKey] = sum;
					}
				}

				return transformedObject;
			}
			const transformedObjectWithSums =
                transformObjectWithSums(transformedObject);
			function replaceValuesBasedOnLogic(obj) {
				const replacedObject = {};
				for (const fieldsetKey in obj) {
					if (obj.hasOwnProperty(fieldsetKey)) {
						const originalValue = obj[fieldsetKey];

						// Apply logic based on fieldsetKey
						let replacedValue;
						switch (fieldsetKey) {
						case "fieldset1":
							replacedValue =
                                    originalValue >= 11
                                    	? "A+"
                                    	: originalValue > 6 &&
                                          originalValue < 11
                                    		? "A"
                                    		: originalValue <= 6
                                    			? "B"
                                    			: "F";
							break;
						case "fieldset2":
							replacedValue =
                                    originalValue >= 22
                                    	? "A+"
                                    	: originalValue > 12 &&
                                          originalValue < 22
                                    		? "A"
                                    		: originalValue <= 12
                                    			? "B"
                                    			: "F";
							break;
						case "fieldset3":
							replacedValue =
                                    originalValue >= 11
                                    	? "A+"
                                    	: originalValue > 6 &&
                                          originalValue < 11
                                    		? "A"
                                    		: originalValue <= 6
                                    			? "B"
                                    			: "F";
							break;
						case "fieldset4":
							replacedValue =
                                    originalValue === 3
                                    	? "A+"
                                    	: originalValue === 2
                                    		? "A"
                                    		: originalValue === 1
                                    			? "B"
                                    			: "F";
							break;
						default:
							replacedValue = originalValue;
						}

						replacedObject[fieldsetKey] = replacedValue;
					}
				}

				return replacedObject;
			}
			const replacedObject = replaceValuesBasedOnLogic(
				transformedObjectWithSums
			);
			return replacedObject;
		}

		function getGradeAsPerName(name) {
			let grade;

			switch (name) {
			case "vMDRScorecardSensorsRange": {
				const vMDRScorecardSensorsRangeCheckedCheckboxes =
                        questionnaireForm.querySelectorAll(
                        	`input[name='${name}']:checked`
                        );
				const vMDRScorecardSensorsSelectedValues = [
					...vMDRScorecardSensorsRangeCheckedCheckboxes,
				].map((checkbox) => checkbox.value);
				grade =
                        Object.keys(sensorsRangeMapping).find((key) =>
                        	sensorsRangeMapping[key].every((value) =>
                        		vMDRScorecardSensorsSelectedValues.includes(
                        			value
                        		)
                        	)
                        ) || "F";

				break;
			}
			case "vMDRScorecardFrequency":
				grade =
                        frequencyMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardPercentage":
				grade =
                        percentageMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardClassifygroup":
				grade =
                        classifyGroupMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardDigitalCertificates":
				grade =
                        digitalCertificatesMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardAuthentication":
				grade =
                        authenticationMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardAgentlessTracking":
				grade =
                        agentlessTrackingMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardMergeVulnerability":
				grade =
                        mergeVulnerabilityMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardExploitableVulnerabilities":
				grade =
                        exploitableVulnerabilitiesMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardSCA":
				grade =
                        sCAMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardPCIASVScanning":
				grade =
                        pCIASVScanningMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardCreateTickets":
				grade =
                        createTicketsMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardPrioritizingVulnerabilities":
				grade =
                        prioritizingVulnerabilitiesMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardPrioritizingAssets":
				grade =
                        prioritizingAssetsMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardMitreATTCK":
				grade =
                        mitreATTCKMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardPatchesDeploy":
				grade =
                        patchesDeployMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			case "vMDRScorecardPurgeRules":
				grade =
                        purgeRulesMapping[
                        	questionnaireForm.querySelector(
                        		`input[name='${name}']:checked`
                        	).value
                        ];
				break;
			default:
				grade = "F"; // Default grade if name doesn't match any case
				break;
			}

			if (grade === undefined) {
				console.error(`input with name ${name} was not found`);
				grade = "F";
			}

			// return grade;
			return { name, grade };
		}

		const urlParams = new URLSearchParams(window.location.search);
		const debugParam = urlParams.get("debug");
		// const gradeAcquiredArray = [];

		function handleInputChange(ele) {
			// disableNextBtn();
			let eleName = ele.target.name;
			let parentFieldWrap = $(ele.target).parents(".question");
			const choicesDiv = $(parentFieldWrap[0]).find(".choices");

			if (choicesDiv.length > 0) {
				// Fetch the checked values and their label texts
				if (debugParam == "true") {
					let gradeAcquired = getGradeAsPerName(eleName);
					const gradesValues = gradeAcquired.grade;
					const toBeInserted = `Points Scored: ${gradeToNumeric[gradesValues]}<br/>Grade Obtained: ${gradesValues}`;
					const quesGradeEle = choicesDiv.children(".ques-grade");
					if (quesGradeEle.length > 0) {
						$(quesGradeEle).html(toBeInserted);
					} else {
						choicesDiv.append(
							`<pre class="ques-grade" style="color: #ED2E26;">${toBeInserted}</pre>`
						);
					}
				}
			}
		}
		let quesCheckboxes = questionnaireForm.querySelectorAll(
			"input[type='checkbox']"
		);
		quesCheckboxes.forEach(function (checkbox) {
			checkbox.addEventListener("change", handleInputChange);
		});
		let quesRadioBtns = questionnaireForm.querySelectorAll(
			"input[type='radio']"
		);
		quesRadioBtns.forEach(function (radio) {
			radio.addEventListener("change", handleInputChange);
		});

		questionnaireForm.addEventListener("submit", function (e) {
			e.preventDefault();
		});
		document.addEventListener("change", function (event) {
			if (event.target.matches(".swiper-slide-active input")) {
				disableNextBtn();
			}
		});

		form.onSubmit(function (form) {
			var $form;
			var selectedValues = {};
			var labeltxt;
			var inputs = questionnaireForm.querySelectorAll("input");
			for (var input of inputs) {

				if (input.type === "radio" && input.checked) {
					labeltxt = input.closest("label").textContent.trim();
					selectedValues[input.name] = labeltxt;
				} else if (input.type === "checkbox" && input.checked) {
					if (!selectedValues[input.name]) {
						selectedValues[input.name] = [];
					}
					labeltxt = input.closest("label").textContent.trim();
					selectedValues[input.name].push(labeltxt);
				}

				var mktoFormEle = document.querySelector(".mktoForm.q-form");
				var hiddenField = mktoFormEle.querySelector(`[name="${input.name}"]`);

				if (hiddenField) {
					hiddenField.value = selectedValues[input.name];
				}
			}

			$form = form.getFormElem();

			const firstName = $form.find("input[name='FirstName']").val();
			const lastName = $form.find("input[name='LastName']").val();
			name = `${firstName} ${lastName}`;
			company = $form.find("input[name='Company']").val();

			const gradesKV = [
				getGradeAsPerName("vMDRScorecardSensorsRange"),
				getGradeAsPerName("vMDRScorecardFrequency"),
				getGradeAsPerName("vMDRScorecardPercentage"),
				getGradeAsPerName("vMDRScorecardClassifygroup"),
				getGradeAsPerName("vMDRScorecardDigitalCertificates"),
				getGradeAsPerName("vMDRScorecardAuthentication"),
				getGradeAsPerName("vMDRScorecardAgentlessTracking"),
				getGradeAsPerName("vMDRScorecardMergeVulnerability"),
				getGradeAsPerName("vMDRScorecardExploitableVulnerabilities"),
				getGradeAsPerName("vMDRScorecardSCA"),
				getGradeAsPerName("vMDRScorecardPCIASVScanning"),
				getGradeAsPerName("vMDRScorecardCreateTickets"),
				getGradeAsPerName("vMDRScorecardPrioritizingVulnerabilities"),
				getGradeAsPerName("vMDRScorecardPrioritizingAssets"),
				getGradeAsPerName("vMDRScorecardMitreATTCK"),
				getGradeAsPerName("vMDRScorecardPatchesDeploy"),
				getGradeAsPerName("vMDRScorecardPurgeRules"),
			];

			const grades = Object.values(gradesKV);
			const sumObject = getSectionGrade(gradesKV);
			const gradesValues = grades.map((item) => item.grade);

			const paramsGradeList = gradesValues.map(function (grade, index) {
				return `q${
					index + 1
				}=${encodeURIComponent(grade.toLowerCase())}`;
			});
			const mappedParams = Object.entries(sumObject).map(
				([index, grade]) => {
					return `s${parseInt(index.slice(-1))}=${encodeURIComponent(
						grade.toLowerCase()
					)}`;
				}
			);

			finalGrade = getFinalGrade(gradesValues);
			params = `grade=${encodeURIComponent(
				finalGrade
			)}&name=${encodeURIComponent(name)}&company=${encodeURIComponent(
				company
			)}&${mappedParams.join("&")}&${paramsGradeList.join("&")}`;
			var baseURL =
                "https://qualys-html-to-pdf-0d3555d590c9.herokuapp.com/generate-pdf";
			var PDFURL = baseURL + "?" + params.toString();
			$form.find("input[name='pDFURL']").val(PDFURL);
			return;
		});

		form.onSuccess(function () {
			const pathname = window.location.pathname;
			window.location = `${pathname}confirm/?${params}`;
			return false;
		});

		return true;
	});

})(jQuery, MktoForms2);

